"use client";
import { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Menu, X } from "lucide-react";

const navLinks = [
  { href: "/models", label: "機種一覧" },
  { href: "/repair-guide", label: "修理ガイド" },
  { href: "/tools", label: "工具一覧" },
];

interface NavbarLinksProps {
  isAdmin: boolean;
}

export default function NavbarLinks({ isAdmin }: NavbarLinksProps) {
  const pathname = usePathname();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      {/* デスクトップ用ナビ */}
      <nav className="hidden sm:flex items-center gap-6 text-sm">
        {navLinks.map((link) => (
          <Link key={link.href} href={link.href}>
            <span
              className={
                pathname === link.href
                  ? "text-primary font-medium transition-colors"
                  : "text-muted-foreground hover:text-foreground transition-colors"
              }
            >
              {link.label}
            </span>
          </Link>
        ))}
        {isAdmin && (
          <Link href="/admin/comments">
            <span className="inline-flex items-center gap-1 text-amber-400 hover:text-amber-300 transition-colors border border-amber-500/30 px-2 py-0.5 rounded text-xs font-mono">
              管理画面
            </span>
          </Link>
        )}
      </nav>

      {/* モバイル用ハンバーガーボタン */}
      <button
        className="sm:hidden p-2 text-muted-foreground hover:text-foreground transition-colors"
        onClick={() => setMenuOpen((v) => !v)}
        aria-label="メニューを開く"
      >
        {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
      </button>

      {/* モバイル用ドロップダウンメニュー */}
      {menuOpen && (
        <div
          className="sm:hidden fixed top-14 left-0 right-0 z-50 border-b border-border/50"
          style={{ background: "oklch(0.12 0.015 260 / 0.97)", backdropFilter: "blur(8px)" }}
        >
          <nav className="container py-3 flex flex-col">
            {navLinks.map((link) => (
              <Link key={link.href} href={link.href} onClick={() => setMenuOpen(false)}>
                <span
                  className={`block px-3 py-3 rounded text-sm transition-colors ${
                    pathname === link.href
                      ? "text-primary font-medium bg-primary/10"
                      : "text-muted-foreground hover:text-foreground hover:bg-accent"
                  }`}
                >
                  {link.label}
                </span>
              </Link>
            ))}
            {isAdmin && (
              <Link href="/admin/comments" onClick={() => setMenuOpen(false)}>
                <span className="block px-3 py-3 rounded text-sm text-amber-400 hover:text-amber-300 hover:bg-amber-500/10 transition-colors">
                  管理画面
                </span>
              </Link>
            )}
          </nav>
        </div>
      )}
    </>
  );
}
